import { useContext } from "react";
import { FaStar } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CartProvider } from "./CartContext";

function Cart({ item }) {
  let { cartitem, addcart, Prodacts } = useContext(CartProvider);
  console.log(cartitem);
  return (
    <div>
      {Prodacts.map((item) => (
        <div className="cart" key={item.id}>
          <div className="image">
            <img src={item.image} alt="" />
          </div>
          <div className="cart-title">
            <Link to={"-burger-test"}>
              <h2>{item.titel}</h2>
            </Link>
          </div>
          <div className="cart-price">
            <div className="price">
              <span>{item.Price}</span>
            </div>
            <div className="rate">
              <FaStar />
              <span>4.5</span>
            </div>
          </div>
          <div className="cart-opiones">
            <div className="opion">
              <FaCheckCircle color="red" size={20} />
              <span>{item.span}</span>
            </div>
            <div className="opion">
              <FaCheckCircle color="red" size={20} />
              <span>{item.spice}</span>
            </div>
          </div>

          <div className="cart-btn">
            <button onClick={() => addcart(item)}>Add To Cart</button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Cart;
